import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getScanIssue } from 'src/services/scan/ScansService';
import { Report } from 'src/types/ReportModel';

export const useGetScanIssue = (scanId: string, issueId: string): UseQueryResult<Report> => {
	return useQuery({
		queryKey: ['issue', scanId, issueId],
		queryFn: () => getScanIssue(scanId, issueId),
		enabled: !!scanId && !!issueId
	});
};
